module.exports = __webpack_public_path__ + "static/media/agreement.877aa170.pdf";